'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ComboboxOptionContext } from './context/combobox-option.context';
import { comboboxOptionLabelRecipe } from './styles/combobox-option-label.styles';
import type { ComboboxOptionLabelPropsInterface } from './types/combobox-option-label.types';

/**
 * @since 10.0.0
 */
export const ComboboxOptionLabel = forwardRef<HTMLSpanElement, ComboboxOptionLabelPropsInterface>(
  (props: ComboboxOptionLabelPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const { disabled, selected } = useContext(ComboboxOptionContext);
    const styles = css(comboboxOptionLabelRecipe.raw({ disabled, selected }), cssProp);
    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Combobox.OptionLabel"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_combobox__option-label', styles, className)}
        {...rest}
      />
    );
  },
);

ComboboxOptionLabel.displayName = 'Combobox.OptionLabel';
